module.exports = __webpack_public_path__ + "img/setting.68026032.png";